import './descope-phone-field-internal';
import '@descope-ui/descope-combo-box';
import '../../descope-text-field';

import { componentName, PhoneFieldClass } from './PhoneFieldClass';

customElements.define(componentName, PhoneFieldClass);

export { PhoneFieldClass, componentName };
